import { render, staticRenderFns } from "./DefaultLayout_HeaderBright.vue?vue&type=template&id=b46ab524&scoped=true"
import script from "./DefaultLayout_HeaderBright.vue?vue&type=script&lang=js"
export * from "./DefaultLayout_HeaderBright.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayout_HeaderBright.vue?vue&type=style&index=0&id=b46ab524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46ab524",
  null
  
)

export default component.exports